import styled, { css } from 'styled-components';

import Button from 'Campaigns/Clearing/Button';

export const Wrapper = styled.div<{
    $decorativeLines: 'option1' | 'option2' | 'none';
    $pseudoBlocks: 'option1' | 'option2' | 'none';
}>`
    ${({ theme, $decorativeLines, $pseudoBlocks }) => css`
        display: inline-block;
        position: relative;

        ${$pseudoBlocks === 'option1'
            ? css`
                  @media ${theme.breakpoints.medium.media} {
                      margin: 0;
                  }
              `
            : $pseudoBlocks === 'option2'
            ? css`
                  padding-bottom: 1rem;
                  margin-right: 0.5rem;

                  @media ${theme.breakpoints.medium.media} {
                      margin-right: 0;
                  }

                  margin: 0.5rem 0.5rem 0;
              `
            : css`
                  @media ${theme.breakpoints.medium.media} {
                      margin: 0;
                  }
              `}

        ${$decorativeLines === 'option1'
            ? css`
                  :before {
                      content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="133" height="24"> <g data-name="Decorative Elements (Front)"> <g data-name="Decorative Lines" fill="none" stroke="%23333"> <path d="M132.5 24V0" /> <path data-name="Line" d="M120.5 24V0M108.5 24V0M96.5 24V0M84.5 24V0M72.5 24V0M60.5 24V0M48.5 24V0M36.5 24V0M24.5 24V0M12.5 24V0M.5 24V0" /> </g> </g></svg>');
                      position: absolute;
                      width: 5.5rem;
                      height: 1rem;
                      overflow: hidden;
                      top: -0.5rem;
                      right: 1rem;
                      z-index: 1;

                      @media ${theme.breakpoints.large.media} {
                          top: -0.75rem;
                          right: 1rem;
                          width: unset;
                          height: unset;
                      }
                  }
              `
            : $decorativeLines === 'option2'
            ? css`
                  :before {
                      content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="49"> <g data-name="Decorative Lines" fill="none" stroke="%23cd1423"> <path data-name="Line 69" d="M0 48.5h24" /> <path data-name="Line 70" d="M0 36.5h24" /> <path data-name="Line 71" d="M0 24.5h24" /> <path data-name="Line 66" d="M0 12.5h24" /> <path data-name="Line 60" d="M0 .5h24" /> </g></svg>');
                      position: absolute;
                      top: 2rem;
                      right: -0.5rem;
                      z-index: 1;
                      width: 1rem;
                      height: 3rem;
                      overflow: hidden;

                      @media ${theme.breakpoints.large.media} {
                          right: -0.75rem;
                          width: 1.5rem;
                      }
                  }
              `
            : ''}
    `}
`;

export const StyledButton = styled(Button)`
    ${({ theme }) => css`
        width: 100%;
        margin-top: 1rem;

        @media ${theme.breakpoints.large.media} {
            width: unset;
            margin-top: 0;
            transform: translateY(-50%);
            margin-left: 1.5rem;
        }
    `}
`;

export const Container = styled.div<{
    $pseudoBlocks: 'option1' | 'option2' | 'none';
    $hasButton: boolean;
    $clearingPromise: boolean;
}>`
    ${({ theme, $pseudoBlocks, $hasButton, $clearingPromise }) => css`
        position: relative;
        background: ${theme.colors.secondary.tints[1].hex};
        padding: 1rem 1.5rem 1rem;

        ${$clearingPromise &&
        css`
            padding: 1rem 2.5rem 1rem 1.5rem;

            @media ${theme.breakpoints.large.media} {
                padding: '1rem 5.5rem 1rem 1.5rem';
            }
        `}

        ul {
            padding-left: 1.25rem;
        }

        li {
            list-style-type: square;
        }

        @media ${theme.breakpoints.large.media} {
            padding: ${$clearingPromise
                ? '1rem 5.5rem 1rem 1.5rem'
                : $hasButton
                ? '1rem 1.5rem 3rem'
                : '1rem 1.5rem'};

            ul {
                padding-left: 2.5rem;
            }
        }

        & :first-child {
            margin-top: 0;
        }

        p:last-of-type {
            margin-bottom: 0;
        }

        ${$pseudoBlocks === 'option1' &&
        css`
            :before {
                content: '';
                position: absolute;
                width: 7.5rem;
                height: 1.5rem;
                top: -0.5rem;
                left: -0.5rem;
                background-color: ${theme.colors.campaigns.clearing.secondary.hex};
                z-index: -1;

                @media ${theme.breakpoints.large.media} {
                    left: -0.5rem;
                    top: -1rem;
                    height: 3.4rem;
                    width: 11.4rem;
                }
            }

            :after {
                content: '';
                position: absolute;
                width: 0.5rem;
                height: 7.5rem;
                bottom: 1rem;
                right: -0.5rem;
                background-color: ${theme.colors.campaigns.clearing.secondary.hex};
                z-index: -1;

                @media ${theme.breakpoints.large.media} {
                    width: 0.8rem;
                    height: 10.5rem;
                    bottom: 2rem;
                    right: -0.8rem;
                }
            }
        `}

        ${$pseudoBlocks === 'option2' &&
        css`
            :after {
                content: '';
                position: absolute;
                width: 4.5rem;
                height: 7.5rem;
                bottom: -1rem;
                right: -0.5rem;
                z-index: -1;
                background-color: ${theme.colors.campaigns.clearing.secondary.hex};

                @media ${theme.breakpoints.large.media} {
                    width: 5.5rem;
                    right: -1rem;
                    bottom: -3rem;
                    height: 10.5rem;
                }
            }
        `}
    `}
`;
